<template>
  <div class="hello">
      <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Loading..</p>
        </div>
    </transition>

    <!-- Buyer profile modal -->
    <!-- Fake call to setup orders -->
    {{ordersArray}}

    <b-container fluid>
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Select Orders to Invoice</h4>
            </b-col>
        </b-row>

        <b-row style="margin-bottom:20px">
            <b-col>
                <b-button @click="createTheInvoicesArray()" class="btn btn-warning action-buttons">Create Invoices</b-button>
            </b-col>
            <!-- Show invoiced and uninvoiced -->
            <b-col>
                <b-button-group>
                    <span style="margin:10px; padding-top:10px" >Show</span>
                    <b-button style="margin:10px" v-if="!showInvoiced" variant="outline-secondary" @click="setShowInvoiced()">Invoiced</b-button>
                    <b-button style="margin:10px"  v-else variant="primary" @click="setShowInvoiced()">Invoiced</b-button>
                    <b-button style="margin:10px" v-if="!showUnInvoiced" variant="outline-secondary" @click="setShowUnInvoiced()">UnInvoiced</b-button>
                    <b-button style="margin:10px" v-else variant="primary" @click="setShowUnInvoiced()">UnInvoiced</b-button>
                </b-button-group>
            </b-col>
        </b-row>

        <!-- Pagination -->
        <b-row>
            <b-col>
                <b-pagination  size="sm"
                    v-model="currentPage"
                    :total-rows="totalLength"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                ></b-pagination>
            </b-col>
            <b-col>
                    <b-form-group  label-size="sm" 
                        label-cols-sm="6"
                        label="Per Page"
                        label-align-sm="right"
                        label-for="size"
                        style="width:auto"
                        >
                        <b-form-select size="sm"
                            style="width:auto"
                        id="size"
                        v-model="perPage"
                        :options="pageOptions"
                        ></b-form-select>
                    </b-form-group>
            </b-col>
        </b-row>
        <!-- End Of Pagination -->

        

        <!-- Orders table -->
        <b-row>
            <table class="table table-striped" style="margin-left:50px; margin-right:50px">
                    <thead class="thead-dark">
                    <tr>
                        <th>
                            Select for Invoicing
                        </th>
                        <th>
                            <form v-if="sortingNewest">       
                                <label v-b-tooltip.hover title="Sort by oldest orders" onmouseover="" style="cursor: pointer;" @click="sortOldest()">Date <font-awesome-icon icon="sort-numeric-up" /></label>
                            </form>
                            <form v-else>       
                                <label v-b-tooltip.hover title="Sort by newest orders" onmouseover="" style="cursor: pointer;" @click="sortNewest()">Date <font-awesome-icon icon="sort-numeric-down" /></label>
                            </form>
                        </th>
                        <th>
                            <form>       
                                <label v-b-tooltip.hover title="Sort by customer name" onmouseover="" style="cursor: pointer;" @click="sortCustomer()">Customer <font-awesome-icon icon="sort-alpha-up" /></label>
                            </form>
                        </th>
                        <th>Order</th>
                        <th>Order Status</th>
                        <th>Mark Paid</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="item in getDisplayArray">
                        <tr :key='item.suborderid' v-if="(!item.invoiced&&showUnInvoiced)||(item.invoiced&&showInvoiced)&&(item.status>-1)">
                            <!-- Show select button if order has not been invoiced. -->
                            <td v-if="!item.invoiced">
                                <b-button v-if="!item.selected" variant="outline-secondary" @click="setOrderSelected(item.suborderid)" style="height:40px; width:40px">
                                </b-button>
                                <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setOrderUnselected(item.suborderid)">
                                    <font-awesome-icon icon="check-square" />
                                </b-button>
                            </td>
                            
                            <!-- Already invoiced. Give option to recreate the invoice. -->
                            <td v-else>
                                <small>Invoice Number <br> {{item.invoicenumber}}</small>
                                <br>
                                <b-button variant="outline-secondary" @click="showInvoiceNumber(item.invoicenumber)">
                                    Show Invoice
                                </b-button>
                                <br>

                                <b-button v-if="!item.selected" variant="outline-secondary" @click="setOrderSelected(item.suborderid)"  style="height:40px; width:40px; margin-top:10px">
                                </b-button>
                                <b-button v-else variant="outline-secondary" @click="setOrderUnselected(item.suborderid)"  style="height:40px; width:40px; margin-top:10px">
                                    <font-awesome-icon icon="check-square" />
                                </b-button>
                                <span style="margin-left:20px; padding-top:20px">Recreate</span>
                            </td>
                            <td>
                                <h6>{{item.dateObject.date}}</h6>
                                <h6>{{item.dateObject.month}}</h6>
                            </td>
                            <td>
                                <div class='customername'><strong>{{item.pub}}</strong></div>
                            </td>

                            <b-modal no-fade  scrollable size="xl" :id="'buyerprofile' + item.suborderid"  :title="item.pub" ok-only ok-variant="secondary" ok-title="Close" hide-footer>
                                <buyerprofile  :buyerId="item.pubid" />
                            </b-modal>

                            <td>
                                {{item.beerName}}. Qty: {{item.orderQuantity}}x{{item.size}}
                                <div style='color:green'>
                                    <h6>${{item.totalCost}}</h6>
                                </div>
                            </td>

                            <!-- Order Status -->
                            <td v-if="item.status==0">Awaiting Acceptance</td>
                            <td v-if="item.status==1">Accepted</td>
                            <td v-if="item.status==2">Shipped</td>
                            <!-- Mark paid button -->
                            <td>
                                <b-button v-if='item.paid!=1' v-b-modal="'MarkPaid' + item.suborderid"  v-b-tooltip.hover title="Mark Paid" class='btn btn-success action-buttons'><i><font-awesome-icon icon="dollar-sign" /></i></b-button>
                                <span v-if="item.paid==1" style="color:grey">Already Paid</span>
                                <b-modal :id="'MarkPaid' + item.suborderid" title="Mark Paid" 
                                    ok-title ='Yes, Mark As Paid'  @ok="markPaid(item.suborderid, item.invoicenumber)" >
                                    <p class="my-4">Mark this order as paid?</p>
                                </b-modal>
                            </td>
                        </tr>
                        
                    </template>
                </tbody>

            </table>
        </b-row>
        <b-row style="margin-bottom:100px">
            <b-col>
                <b-button @click="createTheInvoicesArray()" class="btn btn-warning action-buttons">Create Invoices</b-button>
            </b-col>
        </b-row>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import {copyObject} from '../Myfunctions'
import {createArrayToInvoice} from '../Morefunctions'
import Buyerprofile from '../Buyerprofile'
const fb = require('../../firebaseConfig.js')

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'allBreweryOrders']),
        
        //Create local array so as not to mutate array in store
        ordersArray: function () {
            var localOrders=[]
            for (var i=0; i<this.allBreweryOrders.length; i++){
                var thisOrder = copyObject(this.allBreweryOrders[i])
                thisOrder.selected=0
                localOrders.push(thisOrder)

            } 
            this.theOrders=localOrders
            //return localOrders
            return

        },
        //Get the display aray based on pagination
        getDisplayArray: function () {
            var localDisplayArray
            if(this.sortingNewest||this.sortingOldest||this.sortingCustomer){
                localDisplayArray = this.displayArray
            }

            else localDisplayArray = this.theOrders

            var paginatedList = []
            this.totalLength = localDisplayArray.length
            var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)
            var indexStop = indexStart + parseInt(this.perPage)

            if (indexStop>localDisplayArray.length) indexStop = localDisplayArray.length
            for (var k = indexStart; k<indexStop; k++){
                paginatedList.push(localDisplayArray[k])
            }

            //console.log(paginatedList)
            return paginatedList
        }
        
    },

    components: {
        Buyerprofile,
    },

    data() {
        return {
            performingRequest:false,
            theOrders:[],
            displayArray:[],
            sortingNewest:false,
            sortingOldest:false,
            sortingCustomer:false,
            selected:[],
            currentPage:1,
            perPage:10,
            totalLength:'',
            showInvoiced:true,
            showUnInvoiced:true,
            pageOptions: [
                { value: '10', text: '10' },
                { value: '25', text: '25' },
                { value: '50', text: '50' },
                { value: '9999999999999', text: 'All' },
                ],
        }
    },

    methods:{
        pageChanged(){
            window.scrollTo(0,0)
        },
        //Show and hide invoiced and uninvoiced
        setShowInvoiced(){
            this.showInvoiced=!this.showInvoiced
        },
        setShowUnInvoiced(){
            this.showUnInvoiced=!this.showUnInvoiced
        },

        sortNewest(){
            this.showAnimation = true
            this.animationTitle="Sorting"
            setTimeout(() => { this.showAnimation = false }, 1500)
            this.displayArray = this.theOrders
            this.currentPage = 1
            
            function compare(a, b) {
                const costA = parseInt(a.createdOn.seconds)
                const costB = parseInt(b.createdOn.seconds)
                let comparison = 0;
                if (costA <costB) {
                        comparison = 1;
                } else if (costA>costB) {
                        comparison = -1;
                }
                    return comparison;
            }
            this.displayArray.sort(compare);
            this.sortingNewest=true
            this.sortingOldest=false
            this.sortingCustomer=false
        },
        sortOldest(){
            this.showAnimation = true
            this.animationTitle="Sorting"
            setTimeout(() => { this.showAnimation = false }, 1500)
            this.displayArray = this.theOrders
            this.currentPage = 1
            
            function compare(a, b) {
                const costA = parseInt(a.createdOn.seconds)
                const costB = parseInt(b.createdOn.seconds)
                let comparison = 0;
                if (costA >costB) {
                        comparison = 1;
                } else if (costA<costB) {
                        comparison = -1;
                }
                    return comparison;
            }
            this.displayArray.sort(compare);
            this.sortingNewest=false
            this.sortingOldest=true
            this.sortingCustomer=false
        },
        
        sortCustomer(){
            this.showAnimation = true
            this.animationTitle="Sorting"
            setTimeout(() => { this.showAnimation = false }, 1500)
            this.displayArray = this.theOrders
            this.currentPage = 1
            function compare(a, b) {
                var costA = a.pub.toUpperCase()
                var costB = b.pub.toUpperCase()
                let comparison = 0;
                if (costA >costB) {
                        comparison = 1;
                } else if (costA<costB) {
                        comparison = -1;
                }
                    return comparison;
            }
            this.displayArray.sort(compare);
            this.sortingNewest=false
            this.sortingOldest=false
            this.sortingCustomer=true
        },
        setOrderSelected(suborderid){
            for (var i=0; i<this.theOrders.length; i++){
                if (this.theOrders[i].suborderid==suborderid){
                    this.theOrders[i].selected=1
                    break
                }
            }
        },
        setOrderUnselected(suborderid){
            for (var i=0; i<this.theOrders.length; i++){
                if (this.theOrders[i].suborderid==suborderid){
                    this.theOrders[i].selected=0
                    break
                }
            }
        },

        createInvoice(){
            //Empty out invoices in store
            this.$store.commit('setInvoicesArray',[])
            console.log("Creating invoices")
            var ordersToInvoice=[]
            for (var i=0; i<this.theOrders.length; i++){
                if(this.theOrders[i].selected==1) ordersToInvoice.push(this.theOrders[i])
            }

            var groupedArray=[]
            //Iterate over all orders
            for (var i=0; i<ordersToInvoice.length; i++){
                //To keep track of whether this pub was already found and we must append, or create a new group
                var foundPubArray=false
                //Iterate over groupedArray and see if pubid exists in one of them
                if(groupedArray.length>0){
                    for (var j=0; j<groupedArray.length; j++){
                        
                        //Get order array for each pub
                        var thisOrdersObject=groupedArray[j]
                        //Check if pubid is the same
                        if (thisOrdersObject.pubid==ordersToInvoice[i].pubid){
                            //Found an orders object for this pub
                            var thisPubOrdersArray=thisOrdersObject.orders
                            var invoicenumber=thisOrdersObject.invoicenumber
                            //Append to orders array
                            var thisOrder=ordersToInvoice[i]
                            //Add an empty tax field
                            thisOrder.tax=""
                            //Create itemName
                            thisOrder.itemName=thisOrder.beerName+' '+thisOrder.size

                            thisPubOrdersArray.push(thisOrder)
                            //Create new orders object
                            var newOrdersObject=thisOrdersObject
                            newOrdersObject.orders=thisPubOrdersArray
                            //Replace array element with new object
                            groupedArray.splice(j, 1, newOrdersObject)
                            foundPubArray=true
                        }
                    }
                    //End of for loop over grouped orders array
                }
                //This pub was not found or grouped order array length was 0. Push.
                if(!foundPubArray){
                    var newOrderToPush=ordersToInvoice[i]
                    //Create itemName
                    newOrderToPush.itemName=newOrderToPush.beerName+' '+newOrderToPush.size
                    //Add an empty tax field
                    newOrderToPush.tax=""
                    //Order array for this pub
                    var newOrderArray=[newOrderToPush]
                    //Create invoice number
                    var max=9999999999999999
                    var min=1111111111111111
                    var invoiceNumber=Math.floor(Math.random() * (max - min + 1)) + min;

                    //Orders object for this pub
                    var paymentInstructions="Please make checks payable to "+this.userProfile.company
                    var thisOrdersObject={pubid:newOrderToPush.pubid, pub:newOrderToPush.pub, brewerid:newOrderToPush.brewerid, brewer:newOrderToPush.brewer,invoicenumber:invoiceNumber, 
                    billingaddress:ordersToInvoice[i].deliveryAddress, orders:newOrderArray, paymentinstructions:paymentInstructions, createdbyname:this.userProfile.company, byrep:0}

                    //If rep, use distributorid
                    if(this.userProfile.isbrewer==10){
                        thisOrdersObject.createdbyname = this.userProfile.name
                        thisOrdersObject.byrep=1
                    }
                    thisOrdersObject.createdbyuid=this.currentUser.uid
                    thisOrdersObject.createdbyemail=this.currentUser.email
                    //Append to grouped array.
                    groupedArray.push(thisOrdersObject)

                }
            }

            //Add four rows to each grouped array for user to enter any new items in the same invoice
            var emptyRow={}
            emptyRow.orderDate=""
            emptyRow.beerName=""
            emptyRow.orderQuantity=""
            emptyRow.totalCost=""
            emptyRow.tax=""
            emptyRow.itemName=""

            var groupedArrayWithEmptyRows=[]
            for (var j=0; j<groupedArray.length; j++){
                var newGroupWithEmptyRows=groupedArray[j]
                
                var thisOrderArray=newGroupWithEmptyRows.orders
                thisOrderArray.push(emptyRow)
                thisOrderArray.push(emptyRow)
                thisOrderArray.push(emptyRow)
                thisOrderArray.push(emptyRow)
                newGroupWithEmptyRows.orders=thisOrderArray
                groupedArrayWithEmptyRows.push(newGroupWithEmptyRows)
            }


            //End of orders array
            console.log("Grouped array = ")
            console.log(groupedArray)
            this.$store.commit('setInvoicesArray',groupedArrayWithEmptyRows)

            this.$router.push({ path: 'invoicescreated', query: { orders: ordersToInvoice }})
        },
        createTheInvoicesArray(){
            //Empty out invoices in store
            this.$store.commit('setInvoicesArray',[])
            console.log("Creating invoices")
            var ordersToInvoice=[]
            for (var i=0; i<this.theOrders.length; i++){
                if(this.theOrders[i].selected==1) ordersToInvoice.push(this.theOrders[i])
            }

            var groupedArray=createArrayToInvoice(ordersToInvoice, this.userProfile.company)


            //End of orders array
            console.log("Grouped array = ")
            console.log(groupedArray)
            this.$store.commit('setInvoicesArray',groupedArray)

            this.$router.push({ path: 'invoicescreated'})
        },
        showInvoiceNumber(invoicenumber){
            this.$router.push({ path: 'showinvoice', query: { invoicenumber: invoicenumber }})
        },

        //Mark order and invoice as paid
        markPaid(suborderid, invoicenumber){
            //Mark order as paid

            //If there was an invoice number (item was invoiced), mark all orders with that invoice number as paid
            if(invoicenumber){
                //Mark all orders as paid
                fb.ordersCollection.where('invoicenumber', '==', invoicenumber).get().then(docs => {
                    docs.forEach(doc => {
                        fb.ordersCollection.doc(doc.id).update({
                            paid:1
                            })
                    })
                }).catch(err => {
                console.log(err)
                })

                //Mark invoice as paid
                fb.invoicesCollection.where('invoicenumber', '==', invoicenumber).get().then(docs => {
                    docs.forEach(doc => {
                        fb.invoicesCollection.doc(doc.id).update({
                            paid:1
                            })
                    })
                }).catch(err => {
                console.log(err)
                })

            }

            //Item was not invoiced, just mark order as paid
            else{
                fb.ordersCollection.where('suborderid', '==', suborderid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.ordersCollection.doc(doc.id).update({
                            paid:1
                            })
                    })
                }).catch(err => {
                console.log(err)
                })

            }
            

            
        },
    },

    mounted(){
    },
}
</script>

<style scoped>
.customername{
    font-size:10;
}
</style>

